export default __webpack_public_path__ + "static/media/offer6.90b165ad.jpg";